import React, {useEffect} from 'react';
import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingleISO from '../../partials/BlogSingleISO';
import Footer from '../../partials/Footer';

function BlogPostISO() {

  useEffect(() => {
    document.title = `La migration vers la norme ISO 20022 : opportunités et défis| CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingleISO />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostISO;